const checkIfFieldIdHasTag = (tag?: string, id?: string): boolean => {
  switch (id) {
    case 'reference_files_design_content':
      return tag === 'content'
    case 'reference_files_other_references':
      return tag === 'other_references'
    case 'reference_files_artworks':
      return tag === 'artworks'
    case 'references_logo_files':
      return tag === 'logo_files'
    case 'references_brand_style_guide':
      return tag === 'brand_style_guide'
    case 'adapts_main_design':
      return tag === 'adapt_main_design'
    case 'reference_files_infographic_description':
      return tag === 'infographic_description'
    case 'outline_structure':
      return tag === 'outline_structure'
    case 'other_instructions':
      return tag === 'other_instructions_tag'
    case 'other_information':
      return tag === 'other_information_tag'
    default:
      return false
  }
}

export default checkIfFieldIdHasTag
